import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TooltipRebook = () => {
  const { t } = useTranslation();

  return (
    <div className="info-tooltip" data-bem="TooltipRebook">
      <i>{t('clientConnect.tooltipGuide')}</i>
      <div className="client-info-icon">
        <span className="tooltip">
          <div className="tooltip-centered">{t('clientConnect.rebookTooltipText')}</div>
        </span>
      </div>
    </div>
  );
};

export default TooltipRebook;
